
<div [ngSwitch]="modalData?.type">

  <ng-template ngSwitchCase="representative">

    <h1>Representative</h1>

<div class="lessor-data-payment_table" >
  <div class="tab_row">
    <span class="data">Name</span>
    <span class="data">Phone</span>
    <span class="data">Address</span>
    <span class="data">Account Number</span>
    <span class="data">Bank Name</span>
    <span class="data">Representative</span>
    <span class="data">Duration</span>
  </div>
  <div class="tab_row" *ngFor="let representative of transformedLessorRepresentative" (click)="onSubmit(representative, modalData?.type)">
    <span class="data">{{representative?.addressBook?.Name}}</span>
    <span class="data">{{representative?.addressBook?.PhoneNo}}</span>
    <span class="data">{{representative?.addressBook?.Address}}</span>
    <span class="data">{{representative?.addressBook?.AccountNo}}</span>
    <span class="data">{{representative?.addressBook?.BankName}}</span>
    <span class="data">{{getLessorRepTypeName(representative?.addressBook?.LessorRepTypeId)}}</span>
    <span class="data">{{representative?.FromDate | date:'M/d/yyyy'}} - {{representative?.ToDate | date:'M/d/yyyy'}}</span>
  </div>

</div>

</ng-template>

<ng-template ngSwitchCase="stakeholder">

  <h1>Stakeholder</h1>

<div class="lessor-data-payment_table" >
  <div class="tab_row">
    <span class="data">Name</span>
    <span class="data">Phone</span>
    <span class="data">Address</span>
    <span class="data">Account Number</span>
    <span class="data">Bank Name</span>
  </div>
  <div class="tab_row" *ngFor="let stakeholder of transformedLessorStakeholders" (click)="onSubmit(stakeholder, modalData?.type)">
    <span class="data">{{stakeholder?.addressBook?.Name}}</span>
    <span class="data">{{stakeholder?.addressBook?.PhoneNo}}</span>
    <span class="data">{{stakeholder?.addressBook?.Address}}</span>
    <span class="data">{{stakeholder?.addressBook?.AccountNo}}</span>
    <span class="data">{{stakeholder?.addressBook?.BankName}}</span>
  </div>

</div>

</ng-template>

<ng-template ngSwitchCase="lossOfUse">

  <h1>Loss of Use</h1>

<div class="lessor-data-payment_table">
<div class="tab_row">
  <span class="data">Description</span>
  <span class="data">Rate</span>
  <span class="data">Remarks</span>
  <span class="data">UomName</span>

</div>
<div class="tab_row" *ngFor="let lossOfUseItem of modalData?.lossOfUseItems" (click)="onSubmitLossOfUseItems(lossOfUseItem)">
  <span class="data">{{lossOfUseItem?.LossOfUseItemDesc}}</span>
  <span class="data">{{lossOfUseItem?.Rate }}</span>
  <span class="data">{{lossOfUseItem?.Remarks }}</span>
  <span class="data">{{lossOfUseItem?.UomName}}</span>

</div>

</div>
</ng-template>



<ng-template ngSwitchCase="lessorInfo">

    <h1>Lessor</h1>

    <div class="table">
      <div class="table-header table-row">
        <div class="td"></div>
        <div class="td">Name</div>
        <div class="td">Phone</div>
        <div class="td">Survey Area</div>
        <div class="td">Account Number</div>
        <div class="td">Bank Name</div>
        <div class="td">Email</div>
      </div>
      <div class="table-row" *ngFor="let lessorInfo of transformedLessorInfos; let rowIndex = index">
        <div [class.clickable]="isRowClickable(rowIndex)" (click)="expanded[lessorInfo.id] = !expanded[lessorInfo?.id]">
          <div class="td">
            <span  *ngIf="isRowClickable(rowIndex)">
              <span *ngIf="expanded[lessorInfo?.id]">-</span>
            <span *ngIf="!expanded[lessorInfo?.id]">+</span>
            </span>
          </div>
          <span class="td">{{lessorInfo?.LandOwnershipTypeName}}</span>
          <span class="td">{{lessorInfo?.PhoneNo }}</span>
          <span class="td">{{getSurveyArea(lessorInfo) }}</span>
          <span class="td">{{lessorInfo?.AccountNo}}</span>
          <span class="td">{{lessorInfo?.BankName}}</span>
          <span class="td">{{lessorInfo?.Email}}</span>

          <div [@detailExpand]="expanded[lessorInfo?.id] ? 'expanded' : 'collapsed'" (click)="$event.stopImmediatePropagation()">
            <div class="table-header table-row">
              <div class="td">Terrain</div>
              <div class="td">Net Area</div>
              <div class="td">UOM</div>
              <div class="td">Remarks</div>
            </div>
          <div class="child-row" *ngFor="let childrow of lessorInfo?.children" (click)="onSubmitLessor(lessorInfo, childrow, modalData?.type)">

            <div class="td">{{getTerrainName(childrow?.TerrainId)}}</div>
            <div class="td">{{childrow?.NetArea}}</div>
            <div class="td">{{getMeasureName(childrow?.MeasureId)}}</div>
            <div class="td">{{childrow?.Remarks}}</div>


          </div>

          </div>
        </div>
      </div>
    </div>

</ng-template>


</div>
